import axios, { API_BASE, handler } from './http-service';

const baseURL = `${API_BASE}/updates`;


export const fetch = async () => {
  return handler(() => axios.get(baseURL));
}

export const findById = async (id: string) => {
  return handler(() => axios.get(`${baseURL}/${id}`));
}

export const create = async (type: string) => {
  return handler(() => axios.post(baseURL, { type }));
}

export const update = async (id: string, data: { type: string }) => {
  return handler(() => axios.put(`${baseURL}/${id}`, data));
}

export const remove = async (id: string) => {
  return handler(() => axios.delete(`${baseURL}/${id}`));
}

export const addFile = async (id: string, data: FormData) => {
  return handler(() => axios.put(`${baseURL}/${id}/files`, data));
}

export const removeFile = async (id: string, filename: string) => {
  return handler(() => axios.delete(`${baseURL}/${id}/files/${filename}`));
}

export const changeEnable = async (id: string, enable: boolean) => {
  return handler(() => axios.put(`${baseURL}/${id}/enable/`, { enable }));
}

export const changeDevelopMode = async (id: string, developMode: boolean) => {
  return handler(() => axios.put(`${baseURL}/${id}/developMode`, { developMode }));
}

export const addDevelopDevice = async (id: string, serial: string) => {
  return handler(() => axios.put(`${baseURL}/${id}/developDevices`, { serial }));
}

export const deleteDevelopDevice = async (id: string, serial: string) => {
  return handler(() => axios.delete(`${baseURL}/${id}/developDevices/${serial}`));
}

const updateService = {
  fetch,
  findById,
  create,
  update,
  remove,
  addFile,
  removeFile,
  changeEnable,
  changeDevelopMode,
  addDevelopDevice,
  deleteDevelopDevice
};

export default updateService;
